import queryString from 'query-string';

export const fetchCollectedStatistics = async ({ organizationId, from, to, baseURL }) => {
    const query = queryString.stringify({ from, to });
    const url = baseURL.concat(`/api/private/organization/${organizationId}/statistics/collected?${query}`);
    const response = await fetch(url);

    return await response.json();
};
export const fetchVisitedStatistics = async ({ organizationId, from, to, baseURL }) => {
    const query = queryString.stringify({ from, to });
    const url = baseURL.concat(`/api/private/organization/${organizationId}/statistics/visits?${query}`);
    const response = await fetch(url);

    return await response.json();
};

export const fetchOrganizationGiversStatistics = async ({ organizationId, from, to, baseURL }) => {
    const query = queryString.stringify({ from, to });
    const url = baseURL.concat(`/api/private/organization/${organizationId}/statistics/givers?${query}`);
    const response = await fetch(url);

    return await response.json();
};

export const fetchTotalCollectedSumStatistics = async ({ organizationId, dateFrom, dateTo, baseURL }) => {
    const query = queryString.stringify({ dateFrom, dateTo });
    const url = baseURL.concat(`/api/private/organization/${organizationId}/statistics/total-collected-sum?${query}`);
    const response = await fetch(url);

    const result = await response.json();
    if (!response?.ok) {
        throw new Error(result?.errors?.global);
    }
    return result?.value;
};

export const fetchNumberOfProjectsStatistics = async ({ organizationId, dateFrom, dateTo, baseURL }) => {
    const query = queryString.stringify({ dateFrom, dateTo });
    const url = baseURL.concat(`/api/private/organization/${organizationId}/statistics/number-of-projects?${query}`);
    const response = await fetch(url);

    const result = await response.json();
    if (!response?.ok) {
        throw new Error(result?.errors?.global);
    }
    return result?.value;
};

export const fetchNumberOfUniqueGiversStatistics = async ({ organizationId, dateFrom, dateTo, baseURL }) => {
    const query = queryString.stringify({ dateFrom, dateTo });
    const url = baseURL.concat(
        `/api/private/organization/${organizationId}/statistics/number-of-unique-givers?${query}`
    );
    const response = await fetch(url);

    const result = await response.json();
    if (!response?.ok) {
        throw new Error(result?.errors?.global);
    }
    return result?.value;
};

export const fetchAverageDonationStatistics = async ({ organizationId, dateFrom, dateTo, baseURL }) => {
    const query = queryString.stringify({ dateFrom, dateTo });
    const url = baseURL.concat(`/api/private/organization/${organizationId}/statistics/average-donation?${query}`);
    const response = await fetch(url);

    const result = await response.json();
    if (!response?.ok) {
        throw new Error(result?.errors?.global);
    }
    return result?.value;
};

export const fetchNumerOfRecurringGiversStatistics = async ({ organizationId, dateFrom, dateTo, baseURL }) => {
    const query = queryString.stringify({ dateFrom, dateTo });
    const url = baseURL.concat(
        `/api/private/organization/${organizationId}/statistics/count-recurring-givers?${query}`
    );
    const response = await fetch(url);

    const result = await response.json();
    if (!response?.ok) {
        throw new Error(result?.errors?.global);
    }
    return result?.value;
};

export const fetchNumerOfGiverdataTransactionsStatistics = async ({ organizationId, dateFrom, dateTo, baseURL }) => {
    const query = queryString.stringify({ dateFrom, dateTo });
    const url = baseURL.concat(
        `/api/private/organization/${organizationId}/statistics/num-giverdata-transactions?${query}`
    );
    const response = await fetch(url);

    const result = await response.json();
    if (!response?.ok) {
        throw new Error(result?.errors?.global);
    }
    return result?.value;
};
